export default __webpack_public_path__ + "static/media/dashboard.14ab9dcf.png";